module.exports = __webpack_public_path__ + "img/email-icon-blue.5fb3a809.svg";